import { createI18n } from "vue-i18n";

// Idioma inicial
const savedLocale =
    localStorage.getItem("locale") || navigator.language || "pt-BR";

// Carrega todos os JSONs de tradução
function loadLocaleMessages() {
    const locales = import.meta.glob("../locales/**/**/*.json", {
        eager: true,
    });
    const messages = {};

    for (const path in locales) {
        const match = path.match(/\.\/locales\/([^\/]+)\/(.+)\.json$/);

        if (match) {
            const locale = match[1];
            const keyPath = match[2].split("/");
            let current = (messages[locale] = messages[locale] || {});

            for (let i = 0; i < keyPath.length; i++) {
                const key = keyPath[i].replace(/\.json$/, "");
                if (i === keyPath.length - 1) {
                    current[key] = {
                        ...current[key],
                        ...(locales[path].default || locales[path]),
                    };
                } else {
                    current[key] = current[key] || {};
                    current = current[key];
                }
            }
        }
    }

    return messages;
}

const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: "pt-BR",
    messages: loadLocaleMessages(),
});

export default i18n;
